import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';

export const FlowNameChanged = createAction('[Flows: Edit Flow]: Flow Name Changed', props<{ flowName: string }>());

export const FlowContextChanged = createAction(
  '[Flows: Edit Flow]: Flow Context Changed',
  props<{ flowContext: string }>(),
);

export const MarkActiveChanged = createAction('[Flows: Edit Flow]: mark Active Changed');

export const UserSubmitted = createAction('[Flows: Edit Flow]: User Submitted');

export const ValidateFlow = createAction('[Flows: Edit Flow]: Validate Flow');

export const ValidateFlowSuccess = createAction(
  '[Flows: Edit Flow]: Validate Flow Success',
  props<{ res: QcResponse }>(),
);

export const ValidateFlowFailed = createAction(
  '[Flows: Edit Flow]: Validate Flow Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateJsonData = createAction(
  '[Flows: Edit Flow]: Update Json Data',
  props<{ jsonData: any; sourceId?: string }>(),
);

export const UpdateJsonDataSimple = createAction(
  '[Flows: Edit Flow]: Update Json Data Simple',
  props<{ task: any; key: any; value: any; allowableValue?: any }>(),
);

export const ResetJsonData = createAction('[Flows: Edit Flow]: Reset Json Data');

export const ResetClearJsonData = createAction('[Flows: Edit Flow]: Reset Clear Json Data');

export const InvalidJSONFile = createAction('[Flows: Edit Flow]: Invalid JSON File');

export const DownloadJSONFile = createAction('[Flows: Edit Flow]: Download JSON File');

export const ValidateJSON = createAction('[Flows: Edit Flow]: Validate JSON');

export const ValidateJSONSuccess = createAction(
  '[Flows: Edit Flow]: Validate JSON Success',
  props<{ res: QcResponse }>(),
);

export const ValidateJSONFailed = createAction(
  '[Flows: Edit Flow]: Validate JSON Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateJSON = createAction('[Flows: Edit Flow]: Create JSON');

export const SaveJSON = createAction('[Flows: Edit Flow]: Save JSON');

export const SaveJSONSuccess = createAction('[Flows: Edit Flow]: Save JSON Success', props<{ res: QcResponse }>());

export const SaveJSONFailed = createAction(
  '[Flows: Edit Flow]: Save JSON Failed',
  props<{ error: HttpErrorResponse }>(),
);
